module.exports = __webpack_public_path__ + "media/coffee-preferences/brew_method_other-5f8c9628.png";